import { ScoreboardSettings } from "../../Api/disciplinePackages";
import { ScoreboardType } from "../../Scoreboard/Common/types";
import { normalizeBreakBetweenRoundsSelection, shouldShowBreakBetweenRounds } from "./mmaBreakBetweenRounds";
import { normalizeWrestlingBreakSelection } from "./wrestlingBreakBetweenRounds";

const KATA_DEFAULTS: ScoreboardSettings = {
    numberOfJudges: 7,
    showTimer: false,
    discardMinMax: true,
    calculationMethod: "sum",
    showFullClassificationAfterPerformance: false,
};

export function resetScoreboardSettingsForType(scoreboardType: ScoreboardType): ScoreboardSettings {
    return normalizeScoreboardSettings(scoreboardType, {});
}

export function normalizeScoreboardSettings(
    scoreboardType: ScoreboardType,
    settings: ScoreboardSettings | null | undefined,
): ScoreboardSettings {
    const raw = settings ?? {};

    switch (scoreboardType) {
        case "wrestling":
            return normalizeWrestlingSettings(raw, 2);
        case "grappling":
            return normalizeWrestlingSettings(raw, 1);
        case "mmaBasic":
            return normalizeMmaSettings(raw);
        case "kata":
            return { ...KATA_DEFAULTS, ...raw };
        default:
            return {};
    }
}

function normalizeWrestlingSettings(settings: ScoreboardSettings, defaultNumberOfRounds: 1 | 2): ScoreboardSettings {
    const numberOfRounds = settings.numberOfRounds === 1 || settings.numberOfRounds === 2 ? settings.numberOfRounds : defaultNumberOfRounds;

    return {
        numberOfRounds,
        breakBetweenRounds: numberOfRounds >= 2 ? normalizeWrestlingBreakSelection(settings.breakBetweenRounds) : null,
    };
}

function normalizeMmaSettings(settings: ScoreboardSettings): ScoreboardSettings {
    const numberOfRounds = settings.numberOfRounds ?? null;

    return {
        numberOfRounds,
        breakBetweenRounds: shouldShowBreakBetweenRounds(numberOfRounds)
            ? normalizeBreakBetweenRoundsSelection(settings.breakBetweenRounds)
            : null,
    };
}
